import React, { useState, useEffect } from "react";
import {
  ArrowLeft,
  PlusCircle,
  Eye,
  Edit,
  Edit2,
  Trash2,
  Upload,
} from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { message, Popconfirm, Switch } from "antd";
import {
  useDeleteJobMutation,
  useGetEmpJobsQuery,
  useGetJobsQuery,
} from "AppQuries/project/task";
import moment from "moment";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import useTableExport from "core/Operations/useTableExport";
import { toast } from "core/Operations/toast";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};
const Task = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const [attendanceFilterDate, setAttendanceFilterDate] = useState({
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });

  const {
    data: ItemData,
    isLoading,
    isPending,
    isError,
    error,
    refetch: GetItems,
  } = useGetEmpJobsQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      employeeCode: 0,
      projectCode: 0,
      jobCode: 0,
      fromDate:
        attendanceFilterDate.fromDate || format(new Date(), "yyyy-MM-dd"),
      toDate: attendanceFilterDate.toDate || format(new Date(), "yyyy-MM-dd"),
    },
    {
      enabled: userData?.companyCode,
    },
  );

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const { mutate: deleteItem, isPending: isDeleting } = useDeleteJobMutation();

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully");
          GetItems();
        } else {
          toast.danger(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.danger(error.message || "Something went wrong.");
      },
    });
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    // {
    //   title: "S.No",
    //   dataIndex: "id",
    //   sorter: (a, b) => a.id.length - b.id.length,
    //   render: (text, record) => <>{text}</>,
    // },
    {
      title: "Project Name",
      dataIndex: "projectName",
      sorter: (a, b) => a.projectName.length - b.projectName.length,
      fixed: "left",
      filters: Array.from(
        new Set(ItemData?.map((d) => d?.projectName).filter(Boolean)),
      ).map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.projectName?.startsWith(value),
    },
    {
      title: "Job Name",
      dataIndex: "jobTitle",
      sorter: (a, b) => a.jobTitle.length - b.jobTitle.length,
      fixed: "left",
    },
    {
      title: "Job Start Date",
      dataIndex: "jobStartDate",
      sorter: (a, b) => a.jobStartDate.length - b.jobStartDate.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Job End Date",
      dataIndex: "jobEndDate",
      sorter: (a, b) => a.jobEndDate.length - b.jobEndDate.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Job Start Time",
      dataIndex: "jobStartTime",
      sorter: (a, b) => a.jobStartTime.length - b.jobStartTime.length,
      render: (text, record) => moment(text, ["HH:mm"]).format("hh:mm A"),
    },
    {
      title: "Job End Time",
      dataIndex: "jobEndTime",
      sorter: (a, b) => a.jobEndTime.length - b.jobEndTime.length,
      render: (text, record) => moment(text, ["HH:mm"]).format("hh:mm A"),
    },
    {
      title: "Job Status",
      dataIndex: "jobStatus",
      sorter: (a, b) => a.jobStatus.length - b.jobStatus.length,
      filters: Array.from(
        new Set(ItemData?.map((d) => d?.jobStatus).filter(Boolean)),
      ).map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.jobStatus?.startsWith(value),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      sorter: (a, b) => a.priority.length - b.priority.length,
    },
    {
      title: "Assigned By",
      dataIndex: "assignedBy",
      sorter: (a, b) => a.assignedBy.length - b.assignedBy.length,
    },
    {
      title: "Involved Emp",
      dataIndex: "jobDetailsList",
      sorter: (a, b) => a.jobDetailsList.length - b.jobDetailsList.length,
      render: (text, record) =>
        record?.jobDetailsList?.map((e) => {
          return `${e.employeeName},`;
        }),
    },
    {
      title: "remarks",
      dataIndex: "remarks",
      sorter: (a, b) => a.remarks.length - b.remarks.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badge rounded-pill bg-outline-success">Active</div>
          )}
          {text === false && (
            <div className="badge rounded-pill bg-outline-danger">
              In Active
            </div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.project_management}
            accessCode={accessCodes.project_task}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.project}${all_routes.task_list}${all_routes.edit_task}/${record.jobCode}`}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.project_management}
            accessCode={accessCodes.project_task}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.jobCode)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns,
  );

  const { onJobExcelDownload } = useTableExport({
    columns: columns.filter(
      (c) => c.title !== "Status" || c.title !== "Action",
    ),
    data: filteredData,
    fileName: "job Details",
    pdfTheme: "",
  });

  // useEffect(() => {
  //   if (isMount) GetItems();

  //   setIsMount(true);
  // }, [showActiveOnly]);

  if (isLoading || isPending) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}

          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Task</h4>
                <h6>Manage Task Details</h6>
              </div>
            </div>

            {/* <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName={`Job Details Report`}
                pdfTheme="plain"
                refresh={GetItems}
              />
            </div> */}

            <div className="page-btn">
              <RangePicker
                disabledDate={disabled7DaysDate}
                className="form-control"
                style={{ display: "flex" }}
                onChange={(date, dateFormat) => {
                  setAttendanceFilterDate({
                    fromDate: dateFormat[0] || format(new Date(), "yyyy-MM-dd"),
                    toDate: dateFormat[1] || format(new Date(), "yyyy-MM-dd"),
                  });
                  GetItems();
                }}
                defaultValue={[
                  dayjs(attendanceFilterDate.fromDate, "YYYY-MM-DD"),
                  dayjs(attendanceFilterDate.toDate, "YYYY-MM-DD"),
                ]}
                // format="DD-MM-YYYY"
              />
            </div>
            <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onJobExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div>
            <div className="page-btn">
              <Can
                accessModule={accessCodes.project_management}
                accessCode={accessCodes.project_task}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Add New Task</Tooltip>}
                >
                  <Link
                    to={`${all_routes.project}${all_routes.task_list}${all_routes.add_task}`}
                    className="btn btn-added"
                  >
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="table-responsive"
                style={{ padding: "0px 0px 20px" }}
              >
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                  pagination={true}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Task;
